import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { setSessionExpiredCallback } from '../utils/apiInterceptor'
import './SessionMonitor.css'

/**
 * Session Monitor Component
 * Monitors for session expiration and shows notifications
 */
const SessionMonitor = () => {
  const [notification, setNotification] = useState(null)
  const { logout } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    // Set up session expiration handler
    setSessionExpiredCallback(() => {
      setNotification({
        type: 'error',
        message: 'Your session has expired. Please log in again.',
      })

      // Auto-logout and redirect after 3 seconds
      setTimeout(async () => {
        await logout()
        navigate('/login')
      }, 3000)
    })

    return () => {
      // Clean up
      setSessionExpiredCallback(null)
    }
  }, [logout, navigate])

  // Auto-hide notification after 10 seconds
  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => {
        setNotification(null)
      }, 10000)

      return () => clearTimeout(timer)
    }
  }, [notification])

  if (!notification) {
    return null
  }

  return (
    <div className={`session-notification ${notification.type}`}>
      <div className="notification-content">
        <svg
          className="notification-icon"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
        <div className="notification-message">
          <strong>Session Expired</strong>
          <p>{notification.message}</p>
          <p className="notification-subtext">Redirecting to login...</p>
        </div>
        <button
          className="notification-close"
          onClick={() => setNotification(null)}
          aria-label="Close notification"
        >
          ×
        </button>
      </div>
    </div>
  )
}

export default SessionMonitor
